<template>

    <div :class="['form-group', { 'mb-4': !removeMargin }]">
        <label for="vehicle_type_id">
            <strong>
                Vehicle Type
                <span v-if="required" class="text-danger">*</span>
            </strong>
        </label>

        <v-select
            v-model="model"
            input-id="vehicle_type_id"
            :options="vehicleTypes"
            label="type"
            :clearable="!isDisabled"
            placeholder="Select a Vehicle Type"
            @search="fetchOptions"
            :disabled="isDisabled"
        ></v-select>

        <div v-if="errors?.length > 0" >
            <div class="alert alert-danger mt-2" role="alert" v-for="(error, index) in errors" :key="index">
                {{ error }}
            </div>
        </div>
    </div>

</template>

<script setup>

import axios from 'axios';
import debounce from 'lodash/debounce';
import VSelect from 'vue-select';
import { ref, onMounted, watch } from 'vue';

const props = defineProps({
    type: {
        type: Number,
        default: null,
        required: false
    },
    old: {
        type: String,
        required: false
    },
    errors: {
        type: Array,
        required: false
    },
    disableWhenPassedVehicle: {
        type: Boolean,
        default: false,
        required: false
    },
    removeMargin: {
        type: Boolean,
        default: false,
        required: false
    },
    required: {
        type: Boolean,
        default: false,
        required: false
    }
});

const model = defineModel({
    type: Object,
    default: null
});

const vehicleTypes = ref([]);
const isDisabled = ref(false);

const fetchVehicleTypes = async () => {
    try {
        const { data } = await axios.get(generateVehicleTypesRoute());
        vehicleTypes.value = Array.isArray(data) ? data : Object.values(data);
    } catch (error) {
        console.log(error);
    }
};

const fetchOptions = (search, loading) => {
    if (search.length > 2) {
        debounceFetchOptions(search, loading);
    }
};

const debounceFetchOptions = debounce(async (search, loading) => {
    try {
        loading(true);
        const url = generateVehicleTypesRoute() + '?search=' + encodeURIComponent(search);
        const { data } = await axios.get(url);
        vehicleTypes.value = Array.isArray(data) ? data : Object.values(data);
    } catch (error) {
        loading(false);
        console.log(error);
    } finally {
        loading(false);
    }
}, 500);

const generateVehicleTypesRoute = () => {
    return route('api.movements.vehicles.types.select');
};

// Set initial state for the model
onMounted(() => {
    fetchVehicleTypes();
});

// Because @open was deprecated, we need to watch the model for null and refresh the list
watch(model, (newValue) => {
    if (newValue === null) {
        fetchVehicleTypes();
    }
});

</script>
